module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Reset Editor Setting</h3>\n</div>\n<div class=\"modal-body\">\n  <p>Are you sure you want to reset the editor settings?</p>\n  <p>You can not undo after you reset.</p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" ng-click=\"cancel()\">No</button>\n  <button class=\"btn btn-primary\" ng-click=\"ok()\">Yes</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/reset-editor.html
 ** module id = 397
 ** module chunks = 0
 **/